import { useState } from "react";
import Api from "../functions/Api";
import { ValidationResponse } from "../functions/validation";

const useContract = ({ handleMuestraSnack, renderActionButton = null }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [ejecutaapi] = Api();
  const [botonSigDisabled, setBotonSigDisabled] = useState(true);
  const [backDisabled, setBackDisabled] = useState(false);
  const [orientation, setOrientation] = useState("");
  const [column] = useState([
    { title: "Nombre desarrollo", field: "NOMBRE_DESARROLLO", type: "string" },
    {
      title: "Nombre del cliente",
      field: "NOMBRECLIENTE",
      type: "string"
    },
    {
      title: "Número de contrato",
      field: "ID_CONTRATO",
      type: "string"
    },
    {
      title: "Estatus del contrato",
      field: "DESCRIPCION",
      type: "string"
    },
    {
      title: "Costo del contrato",
      field: "COSTO_TOTAL",
      type: "datetime",
      editable: "never"
    },
    {
      title: "Saldo actual del contrato",
      field: "SALDO_ACTUAL",
      type: "string",
      editable: "never"
    },
    {
      title: "Acción",
      field: "action",
      render: renderActionButton || undefined
    }
  ]);
  const columnWithAction = renderActionButton
    ? [
        ...column.slice(0, -1),
        {
          title: "Acción",
          field: "action",
          render: rowData => renderActionButton(rowData, handleConfirmContract)
        }
      ]
    : column.filter(c => c.field !== "action");
  const [contracts, setContracts] = useState([]);
  let usuario = localStorage.getItem("user");

  const handleOrientation = event => {
    event.preventDefault();
    const value = event.target.value;

    if (value === "horizontal") {
      setOrientation("horizontal");
    } else {
      setOrientation("vertical");
    }
  };

  const handleConfirmContract = value => {
    const { ID_CONTRATO } = value;
    let body = JSON.stringify({
      pidContrato: ID_CONTRATO,
      usuario: JSON.parse(usuario).email
    });

    ejecutaapi("ConfirmaContrato", body).then(data => {
      let { result, error } = ValidationResponse(data);

      if (error !== "") {
        handleMuestraSnack && handleMuestraSnack(error, "error");
      } else {
        // Verificar si el SP reportó que no se pudo confirmar
        if (result && result.LOTES_ACTUALIZADOS === 0) {
          handleMuestraSnack && handleMuestraSnack(result.MENSAJE || "No se pudo confirmar el contrato", "warning");
        } else {
          handleMuestraSnack &&
            handleMuestraSnack(
              "Contrato confirmado. El crédito está activo.",
              "success"
            );
          // Recargar la lista de contratos
          handleSearchContract(0, "to");
        }
      }
    }).catch(() => {
      handleMuestraSnack && handleMuestraSnack("Error al confirmar contrato", "error");
    });
  };

  const handleSearchContract = (pidContrato, pEstatusContrato) => {
    let body = JSON.stringify({
      pidContrato: pidContrato && pidContrato !== "" ? parseInt(pidContrato, 10) : 0,
      pEstatusContrato: pEstatusContrato && pEstatusContrato !== "0" ? pEstatusContrato : "to",
      usuario: JSON.parse(usuario).email
    });

    ejecutaapi("ObtieneContrato", body).then(data => {
      let { result, error } = ValidationResponse(data);
      if (result != null) setContracts(result);

      if (error !== "") {
        handleMuestraSnack && handleMuestraSnack(error, "error");
      } else {
        if (!result || result.length === 0) {
          handleMuestraSnack &&
            handleMuestraSnack("No se encontraron contratos con los filtros seleccionados", "warning");
        } else {
          handleMuestraSnack &&
            handleMuestraSnack(
              `Se obtuvieron ${result.length} resultado(s)`,
              "success"
            );
        }
      }
    }).catch(() => {
      handleMuestraSnack && handleMuestraSnack("Error al consultar contratos", "error");
    });
  };

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
    setBotonSigDisabled(true);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return {
    handleReset,
    handleBack,
    handleNext,
    activeStep,
    botonSigDisabled,
    handleOrientation,
    orientation,
    setBotonSigDisabled,
    handleConfirmContract,
    column: columnWithAction,
    handleSearchContract,
    contracts,
    backDisabled,
    setBackDisabled
  };
};

export default useContract;
